import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UltraProductSummary.module.scss';
import ValuePropsBox from '../../../views/ProductDetails/Series3CollarDetails/components/ValuePropsBox';
import { Image as FiImage } from '../../Image';
import { ReactComponent as IconDrip } from '../../../assets/images/icons/icon_drip.svg';
import { ReactComponent as IconCellular } from '../../../assets/images/icons/icon_cellular.svg';
import { ReactComponent as IconBatteryCharging } from '../../../assets/images/icons/icon_battery_charging.svg';
import { ReactComponent as IconVibration } from '../../../assets/images/icons/icon_vibration.svg';
import { ReactComponent as IconTarget } from '../../../assets/images/icons/icon_target.svg';
import { ReactComponent as IconMagic } from '../../../assets/images/icons/icon_magic.svg';

export default function UltraProductSummary() {
  const { t } = useTranslation();

  return (
    <div className={styles.specsSection}>
      <div className={styles.hardwareImage}>
        <FiImage
          image={{
            type: 'image',
            url: '/product_images/ultra/unboxing.png',
          }}
        />
      </div>
      <h2 className={styles.specsHeading}>{t('ultra_specs')}</h2>
      <div className={styles.specsGrid}>
        <ValuePropsBox
          className={styles.valuePropsBox}
          columns={1}
          direction="column"
          valueProps={[
            {
              icon: <IconVibration />,
              text: (
                <div className={styles.specItem}>
                  <div className={styles.specHeader}>{t('ultra_positive_reinforcement')}</div>
                  <div className={styles.specBody}>{t('ultra_positive_reinforcement_desc')}</div>
                </div>
              ),
            },
            {
              icon: <IconTarget />,
              text: (
                <div className={styles.specItem}>
                  <div className={styles.specHeader}>{t('ultra_callback_zones')}</div>
                  <div className={styles.specBody}>{t('ultra_callback_zones_desc')}</div>
                </div>
              ),
            },
            {
              icon: <IconCellular />,
              text: (
                <div className={styles.specItem}>
                  <div className={styles.specHeader}>{t('ultra_best_coverage')}</div>
                  <div className={styles.specBody}>{t('ultra_best_coverage_desc')}</div>
                </div>
              ),
            },
            {
              icon: <IconDrip />,
              text: (
                <div className={styles.specItem}>
                  <div className={styles.specHeader}>{t('ultra_waterproof')}</div>
                  <div className={styles.specBody}>{t('ultra_waterproof_desc')}</div>
                </div>
              ),
            },
            {
              icon: <IconBatteryCharging />,
              text: (
                <div className={styles.specItem}>
                  <div className={styles.specHeader}>{t('ultra_battery_life')}</div>
                  <div className={styles.specBody}>{t('ultra_battery_life_desc')}</div>
                </div>
              ),
            },
            {
              icon: <IconMagic />,
              text: (
                <div className={styles.specItem}>
                  <div className={styles.specHeader}>{t('featuring_fi_intelligence')}</div>
                  <div className={styles.specBody}>{t('ask_fi_anything_your_dog_decoded')}</div>
                </div>
              ),
            },
          ]}
        />
      </div>
    </div>
  );
}
